<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center justify-content-between w-100">
        <div v-if="checkPermission('AddSupport')">
          <router-link class="btn btn-primary" to="/ajouter-support">
            <i class="fa fa-plus-circle"></i>
            Ajouter un support de cours
          </router-link>
        </div>
        <div class="d-flex align-items-center">
          <form class="search-box position-relative" @submit.prevent="rechercher">
            <input
              type="text"
              v-model="searchTerm"
              @keyup="rechercher"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Rechercher un support de cours"
            />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Titre</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Niveau</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Filière</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Matière</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Auteur</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Heures</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Modulaire</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(support) in supports" :key="support.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ truncate(support.titre, 60) || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ support.filiereNiveauMatiere?.niveau?.libelle || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ support.filiereNiveauMatiere?.filiere?.libelle || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ support.filiereNiveauMatiere?.matiere?.libelle || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ support.auteur || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ support.nombreHeures }}h
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="support.estModulaire ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ support.estModulaire ? 'Oui' : 'Non' }}
                </span>
                <span v-if="support.estModulaire && support.modules?.length" class="badge bg-info ms-1">
                  {{ support.modules.length }} mod.
                </span>
              </td>

              <!-- Colonne Actions -->
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span
                    class="badge text-white bg-primary fs-15 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>

                  <ul class="dropdown-menu">
                    <!-- Modifier -->
                    <li v-if="checkPermission('EditSupport')">
                      <router-link
                        :to="{ name: 'EditSupportPage', params: { id: support.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>

                    <!-- Détails -->
                    <li>
                      <router-link
                        :to="{ name: 'ViewSupportPage', params: { id: support.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>

                    <!-- Supprimer -->
                    <li v-if="checkPermission('DeleteSupport')">
                      <a
                        href="javascript:void(0);"
                        @click="suppression(support.id, supports, 'supports', `le support ${truncate(support.titre, 30)}`)"
                        class="dropdown-item d-flex align-items-center text-danger"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>

                    <!-- Télécharger le support principal -->
                    <li v-if="support.fichier">
                      <a
                        href="javascript:void(0);"
                        @click.prevent="downloadSupport(support.id)"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-download lh-1 me-8 position-relative top-1"></i>
                        Télécharger le support
                      </a>
                    </li>

                    <!-- Séparateur avant les modules (optionnel mais propre) -->
                    <!-- <li v-if="support.fichier && support.estModulaire && support.modules?.length" role="separator" class="dropdown-divider"></li>

                    <template v-if="support.estModulaire && support.modules?.length">
                      <li class="dropdown-item-text text-muted small ps-3">
                        Modules ({{ support.modules.length }})
                      </li>
                      <li v-for="module in support.modules" :key="module.id">
                        <a
                          href="javascript:void(0);"
                          @click.prevent="downloadModule(module.id)"
                          class="dropdown-item d-flex align-items-center ps-5"
                        >
                          <i class="flaticon-file-1 lh-1 me-8 position-relative top-1"></i>
                          {{ module.code ? `${module.code} - ` : '' }}{{ truncate(module.titre, 30) }}
                        </a>
                      </li>
                    </template> -->
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import ApiService from "../../services/ApiService";
import { suppression, error, success } from "../../utils/utils";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import JwtService from "../../services/JwtService";

export default defineComponent({
  name: "ListeSupportCours",
  components: {
    PaginationComponent,
  },

  setup() {
    const supports = ref<any[]>([]);
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const privileges = ref<string[]>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    // Télécharge le fichier principal du support
const downloadSupport = async (supportId: number) => {
  try {
    // Utilise la route API sécurisée (pas d'URL directe vers /uploads !)
    const response = await ApiService.get(`/supports/${supportId}/download`, {
      responseType: 'blob' // Important pour les fichiers binaires
    });

    // Récupère le nom du fichier depuis les headers (si ton backend le renvoie bien)
    const contentDisposition = response.headers['content-disposition'];
    let filename = `support-${supportId}.pdf`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match?.[1]) filename = match[1];
    }

    // Créer et déclencher le téléchargement
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    success("Support téléchargé avec succès !");
  } catch (err: any) {
    if (err.response?.status === 403 || err.response?.status === 401) {
      error("Accès refusé : vous n'avez pas le droit de télécharger ce fichier.");
    } else if (err.response?.status === 404) {
      error("Fichier introuvable ou supprimé.");
    } else {
      error("Erreur lors du téléchargement du support");
    }
    console.error("Erreur téléchargement support:", err);
  }
};

// Télécharge un fichier de module
const downloadModule = async (moduleId: number) => {
  try {
    const response = await ApiService.get(`/supports/modules/${moduleId}/download`, {
      responseType: 'blob'
    });

    let filename = `module-${moduleId}.pdf`;
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match?.[1]) filename = match[1];
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    success("Module téléchargé avec succès !");
  } catch (err: any) {
    if (err.response?.status === 403 || err.response?.status === 401) {
      error("Accès refusé à ce module.");
    } else {
      error("Erreur lors du téléchargement du module");
    }
  }
};
    onMounted(() => {
      getAllSupports();
    });

    const handlePaginate = ({ page: p, limit: l }: { page: number; limit: number }) => {
      page.value = p;
      limit.value = l;
      getAllSupports();
    };

    // const rechercher = () => {
    //   page.value = 1;
    //   getAllSupports();
    // };

    // function getAllSupports(p = page.value, l = limit.value, search = searchTerm.value) {
    //   const params = new URLSearchParams({
    //     page: p.toString(),
    //     limit: l.toString(),
    //   });
    //   if (search) params.append("searchTerm", search);

    //   return ApiService.get(`/supports?${params.toString()}`)
    //     .then(({ data }) => {
    //       supports.value = data.data.data || [];
    //       totalPages.value = data.data.totalPages || 0;
    //       totalElements.value = data.data.totalElements || 0;
    //       limit.value = data.data.limit || 10;
    //     })
    //     .catch(() => {
    //       error("Impossible de charger les supports de cours");
    //       supports.value = [];
    //     });
    // }

    function getAllSupports(page = 1, limi = 10, searchTerm = "") {
      const query = searchTerm.trim() ? `&mot=${encodeURIComponent(searchTerm.trim())}` : "";
      return ApiService.get(`/all/supports?page=${page}&limit=${limi}${query}&`)
        .then(({ data }) => {
          supports.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur lors du chargement des compositions");
          supports.value = [];
        });
    }

    function rechercher() {
      page.value = 1; 
      getAllSupports(page.value, limit.value, searchTerm.value);
    }

    const truncate = (text: string | undefined, length: number) => {
      if (!text) return "-";
      return text.length > length ? text.substring(0, length) + "..." : text;
    };

    // Fonction de téléchargement corrigée
    const downloadFile = async (filename: string, prefix: string) => {
      try {
        // Construction de l'URL correcte
        const fileUrl = `/uploads/SupportsCours/${filename}`;
        console.log(" Téléchargement depuis:", fileUrl);
        
        const response = await fetch(fileUrl);
        
        if (!response.ok) {
          throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        const extension = filename.split('.').pop();
        link.download = `${prefix}.${extension}`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        success("Fichier téléchargé avec succès");
      } catch (err: any) {
        error("Erreur lors du téléchargement du fichier");
        console.error(" Erreur téléchargement:", err);
      }
    };

    return {
      supports,
      searchTerm,
      page,
      totalPages,
      limit,
      totalElements,
      checkPermission,
      handlePaginate,
      rechercher,
      getAllSupports,
      suppression,
      truncate,
      downloadFile,
      downloadSupport,
      downloadModule,
    };
  },
});
</script>

<style scoped>
.search-box {
  min-width: 300px;
}
</style>